import { WizardPage } from '../../components/wizard/types';
import { ProjectsAndActivitiesModel } from '../../api/models';
import { NestedListProps, NestedListDetailsProp } from '../../components/wizardLayout/wizardNestedListContent/types';
import projects from './modals/projects';
import coreActivities from './modals/coreActivities';
import supportingActivities from './modals/supportingActivities';
import { FieldModel } from '../../components/form/pageForm/types';

const details: NestedListDetailsProp<any>[] = [projects, coreActivities, supportingActivities];

const afiAppGuidanceText = () => {
    return ['AFIAppGuidanceText'];
};

const nestedList: NestedListProps<ProjectsAndActivitiesModel> = {
    addItemButtons: [
        { id: 'btnAddProject', title: 'Add project', itemType: 'Projects' },
        { id: 'btnAddCoreActivity', title: 'Add core activity', itemType: 'CoreActivities' },
        { id: 'btnAddSupportingActivity', title: 'Add supporting activity', itemType: 'SupportingActivities' },
    ],
    details,
    subHeadingContentKey: afiAppGuidanceText,
    list: {
        apiEndpoint: 'projects-and-activities',
        columns: [
            {
                dataField: 'type',
                text: 'Type',
                colWidth: 15,
            },
            {
                dataField: 'referenceNumber',
                text: 'Reference',
                colWidth: 13,
            },
            {
                dataField: 'name',
                text: 'Name',
                colWidth: 37,
            },
            {
                dataField: 'start',
                text: 'Start date',
                colWidth: 9,
            },
            {
                dataField: 'end',
                text: 'End date',
                colWidth: 9,
            },
        ],
    },
};

const projectsAndActivities: WizardPage<ProjectsAndActivitiesModel> = {
    apiEndpoint: '/projects-and-activities',
    name: 'projectsAndActivities',
    title: 'Projects and activities',
    initialPageValues: {

    },
    nestedList,
    enablingPages: [
        'registrationType',
        'rndEntityDetails',
        'contactDetails',
        'applicationInclusions',
    ],
};

export default projectsAndActivities;
